import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../../../../api/request';
import { createFetchContext } from '../../../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../../../components/Info/DisplayError';
import Loading from '../../../../../../../../components/Info/Loading';
import { AuthenticationError } from '../../../../../../../GradeEntry/Loaders/CreateEvaluationGradeEntryBaseLoader';
import { getProgressInCurrentPeriod } from '../../../../../api/academicHistoryRequests';
import { ProgressCurrentPeriod, ProgressCurrentPeriodResponse } from '../types';

export interface BaseLoaderProps {
  studyPlanEnrollmentId: number | string;
  onError?: (code: string, onUnknown?: (() => void) | undefined) => void;
  children: (props: {
    progressCurrentPeriod: ProgressCurrentPeriod[];
    periodActive: boolean;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  ProgressCurrentPeriodResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export const ProgressCurrentPeriodLoaderConsumer = FetchConsumer;

export default function BaseLoader({
  studyPlanEnrollmentId,
  onError,
  children,
}: BaseLoaderProps) {
  const request = useCallback(() => {
    return getProgressInCurrentPeriod(studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            onError && onError(error.code);
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({
            progressCurrentPeriod: data.progressCurrentPeriod,
            periodActive: Boolean(data?.periodActive),
          });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
